class ShpfltMultiProductCustomizerCanvas {
  status;
  baseBg;
  shpfltProductCustomizerNav;

  get activeProductData() {
    return $(".shpflt-product-customizer-item.active").data() ?? null;
  }

  constructor(element) {
    this.element = element;
    // this.baseBg = this.element.dataset["customizerBaseBg"];
    this.status = false;
  }

  activateProduct(productId) {
    this.status = true;
    this.baseBg = $(
      `.shpflt-product-customizer-item[data-product-id='${productId}']`
    ).data("product-customizer-base-bg");
    this.clearCanvas();
  }

  clearCanvas() {
    let ctx = this.element.getContext("2d");
    ctx.clearRect(0, 0, this.element.width, this.element.height);
  }

  addImageToCanvas(image) {
    return new Promise((resolve) => {
      let ctx = this.element.getContext("2d");
      let img = new Image();
      img.src = image;
      img.onload = function () {
        ctx.drawImage(img, 0, 0);
        resolve();
      };
    });
  }

  async addImagesToCanvas(images) {
    if (this.status) {
      this.clearCanvas();
    } else {
      this.status = true;
    }
    if (this.baseBg) {
      this.addImageToCanvas(this.baseBg);
    }
    for (let i = 0; i < images.length; i++) {
      if (
        typeof images[i] === "undefined" ||
        images[i] === "" ||
        images[i] === null
      ) {
        continue;
      }
      await this.addImageToCanvas(images[i]);
    }
  }
}

class ShpfltMultiProductCustomizer extends ShpfltMultiProductCustomizerCanvas {
  bundleCode;

  get activeProduct() {
    return (
      parseInt(
        $(`.shpflt-product-customizer-item.active`).data("product-id")
      ) ?? null
    );
  }

  set activeProduct(productId) {
    if (
      isNaN(this.activeProduct) ||
      (!isNaN(this.activeProduct) && this.activeProduct != productId)
    ) {
      this.activateProduct(productId);
      this.customizeProduct(productId);
    }
  }

  get blockTextileAfterFirstPhase() {
    return (
      $(
        `.shpflt-product-customizer-item[data-product-id='${this.activeProduct}']`
      ).data("block-textile-after-first-phase") === true
    );
  }

  get productPrice() {
    return parseInt(
      $(
        `.shpflt-product-customizer-item[data-product-id='${this.activeProduct}']`
      ).data("product-price")
    );
  }

  set productPrice(price) {
    $(
      `.shpflt-product-customizer-item[data-product-id='${this.activeProduct}'] .customizer-price`
    ).text(price);
  }

  get selectedProductItems() {
    let self = this;
    return $(
      `.shpflt-product-customizer-item[data-product-id='${this.activeProduct}'] .customizer-body`
    )
      .map(function () {
        return {
          name: $(this).data("collection"),
          product: $(this)
            .find(".customizer-product.active")
            .first()
            .map(function () {
              let productVariant = $(this)
                .parents(".shpflt-product-customizer-item")
                .find(
                  ".customizer-product__options.active[data-id='" +
                    $(this).data("id") +
                    "'] variant-radios product-interactive-options"
                );
              if (productVariant.length > 0) {
                productVariant = productVariant.get(0).getCurrentVariant();
                let quantityVal = $(this)
                .parents(".shpflt-product-customizer-item")
                .find(
                  ".customizer-product__options.active[data-id='" +
                    $(this).data("id") +
                    "']"
                )
                .find(
                  ".customizer-product__quantity input:not([type='radio']), .customizer-product__quantity input[type='number']"
                )
                ?.val();
                if (typeof quantityVal !== "undefined") {
                  productVariant.quantity = isNaN(parseInt(quantityVal)) ? 1 : parseInt(quantityVal);
                } else {
                  productVariant.quantity = 1;
                }
                return {
                  id: productVariant.id,
                  name: productVariant.name,
                  title: $(this).data("title") + " - " + productVariant.title,
                  price: productVariant.price,
                  image: $(this).data("customizer-preview"),
                  quantity: productVariant.quantity,
                  properties: $(this)
                    .parents(".shpflt-product-customizer-item")
                    .find(
                      ".customizer-product__options.active[data-id='" +
                        $(this).data("id") +
                        "']"
                    )
                    .find(
                      ".customizer-product__property input:not([type='radio']), .customizer-product__property input[type='radio']:checked"
                    )
                    .map(function () {
                      return {
                        name: $(this).attr("name"),
                        value: $(this).val(),
                      };
                    })
                    .toArray()
                    .reduce((obj, item) => {
                      obj[item.name] = item.value;
                      return obj;
                    }, {}),
                };
              } else {
                return {
                  id: $(this).data("id"),
                  name: $(this).data("name"),
                  title: $(this).data("title"),
                  sku: $(this).data("sku"),
                  price: parseInt($(this).data("price")),
                  image: $(this).data("customizer-preview"),
                };
              }
            })
            .toArray()[0],
          item: $(
            `.shpflt-product-customizer-item[data-product-id='${
              self.activeProduct
            }'] .customizer-item[data-collection='${$(this).data(
              "collection"
            )}']`
          ).first(),
        };
      })
      .toArray();
  }

  constructor(elements) {
    super(document.getElementById("customizer-canvas"));
    this.elements = elements;
    this.shpfltProductCustomizerContainer = $(
      "#shpflt-product-customizer-container"
    );
    this.shpfltProductCustomizerNav = $("#shpflt-product-customizer-nav");
    this.shpfltProductCustomizerItemsContainer = $(
      "#shpflt-product-customizer-items-container"
    );
    this.shpfltProductCustomizerCanvas = $("#customizer-canvas");
    this.shpfltProductCustomizerActionBtn = $(".shpflt-product-customizer-btn");
    this.init();
    this.setupForm();
  }

  setupForm() {
    let self = this;

    this.shpfltProductCustomizerItemsContainer
      .find(".customizer-item")
      .each(function () {
        $(this).init.prototype.getBody = function () {
          let customizerItem = $(this).parents(
            ".shpflt-product-customizer-item"
          );
          return customizerItem.find(
            `.customizer-body[data-collection="${$(this).data("collection")}"]`
          );
        };

        $(this).init.prototype.getRelatedItems = function () {
          return self.shpfltProductCustomizerItemsContainer.find(
            `.customizer-item[data-collection="${$(this).data("collection")}"]`
          );
        };

        $(this).init.prototype.getRelatedTextiles = function () {
          return self.shpfltProductCustomizerItemsContainer.find(
            `.customizer-item[data-collection^="tejido"]`
          );
        };

        $(this).init.prototype.updateSelectedProductText = function () {
          let collection = $(this).data("collection");
          let selectedProduct = self.selectedProductItems.find(
            (s) => s.name === collection
          );
          $(this)
            .find(".customizer-item__text")
            .text(
              selectedProduct.product ? selectedProduct.product.title : "?"
            );
        };
      });

    $("input.product-form__swatch__input[type='radio']").on(
      "change",
      function () {
        if ($(this).val() !== "Al gusto" && $(this).val() !== "Otro") {
          $(this)
            .parents("variant-radios")
            .parent()
            .find(
              `.customizer-product__property[data-variant-name="${$(this).attr(
                "name"
              )}"]`
            )
            .remove();
        }
      }
    );

    ["Al gusto", "Otro"].forEach((value) => {
      $(`input.product-form__swatch__input[type='radio'][value='${value}']`).on(
        "click",
        function () {
          let variantRadiosContainer = $(this).parents("variant-radios");
          let payload = {};
          switch ($(this).attr("name")) {
            case "Color":
              payload = {
                title: "Referencia",
                subtitle: "Introduce la referencia",
                name: "Referencia",
                placeholder: "Introduce la referencia",
                type: "text",
              };
              break;
            case "Anchura":
              payload = {
                title: "Anchura (cm)",
                subtitle: "Introduce la anchura deseada",
                name: "Anchura",
                placeholder: "Introduce la anchura",
                type: "number",
              };
              break;
            default:
              payload = {
                title: "Referencia",
                subtitle: "Introduce la referencia",
                name: "Referencia",
                placeholder: "Introduce la referencia",
                type: "text",
              };
              break;
          }
          if (
            variantRadiosContainer
              .parent()
              .find(
                `.customizer-product__property[data-variant-name="${$(
                  this
                ).attr("name")}"]`
              ).length === 0
          ) {
            let variantName = $(
              this
            ).attr("name");
            let variantValue = $(this).val();
            $(this).parents("fieldset")
              .after(`
              <div class="customizer-product__property" data-variant-name="${$(this).attr("name")}" data-variant-value="${$(this).val()}">
                  <div class="customizer-product__text">
                    <div class="product__text__title">${payload.title}</div>
                    <div class="product__text__subtitle">${payload.subtitle}</div>
                  </div>
                  <input type="${payload.type}" name="${payload.name}" placeholder="${payload.placeholder}" />
              </div>
              ${
                variantName === "Material" && variantValue === "Otro"
                  ? `
                  <div class="customizer-product__quantity">
                      <div class="customizer-product__text">
                        <div class="product__text__title">Precio (€)</div>
                        <div class="product__text__subtitle">Precio del tejido (formato decimal)</div>
                      </div>
                      <input type="number" name="quantity" placeholder="Introduce el precio" step="any" onkeydown="if(event.key==='.'){event.preventDefault();}" />
                  </div>
                `
                  : ""
              }
            `);
          }
        }
      );
    });

    $(".customizer-product__options input:checked").trigger("click");

    $("body").on(
      "click",
      ".product-form__swatch__items__container .product-form__swatch__item input",
      function (e) {
        let container = $(this).parents(
          ".product-form__swatch__items__container"
        );
        if (container.hasClass("selecting")) {
          container.removeClass("selecting");
          container
            .find(".product-form__swatch__item")
            .not($(this).parent(".product-form__swatch__item"))
            .slideUp(200);
        } else {
          e.preventDefault();
          container
            .addClass("selecting")
            .find(".product-form__swatch__item")
            .slideDown(200);
        }
      }
    );
  }
  nextProduct() {
    let self = this;
    $(document.body).on("afterGetCart.ajaxCart", function (event, cart) {
      setTimeout(() => {
        if (
          self.blockTextileAfterFirstPhase &&
          self.elements.length > 1 &&
          self.shpfltProductCustomizerNav.find(".active").index() === 0
        ) {
          let textile = self.selectedProductItems.find((product) => {
            if (product.item.data("title").toLowerCase() === "tejido") {
              return product;
            }
          });
          if (textile && typeof textile.product !== "undefined") {
            $(textile.item.getRelatedTextiles()).each(function () {
              if (textile.product.title.indexOf("Otro Tejido") == 0) return;
              let customizeProduct = $(this)
                .getBody()
                .find(`.customizer-product`);
              customizeProduct
                .data("selected", false)
                .removeClass("active")
                .addClass("disabled");
              $(this)
                  .getBody()
                  .find(`.customizer-product[data-sku='${textile.product.sku}']`)
                  .data("selected", true)
                  .removeClass("disabled")
                  .addClass("active");
            });
          }
        }
        self.shpfltProductCustomizerNav
          .find(
            `.shpflt-product-customizer-nav-item[data-product-id="${self.activeProduct}"]`
          )
          .addClass("completed");
        let nextProduct = self.shpfltProductCustomizerNav.find(
          `.shpflt-product-customizer-nav-item[data-product-id="${self.activeProduct}"] + .shpflt-product-customizer-nav-item`
        );
        if (nextProduct.length) {
          self.activeProduct = nextProduct.data("product-id");
        } else {
          self.toggleProductCustomizer();
        }
      }, 2000);
      $(document.body).off("afterGetCart.ajaxCart");
    });
  }

  init() {
    let self = this;
    if (this.shpfltProductCustomizerItemsContainer.length) {
      if (this.elements.length === 1) {
        self.shpfltProductCustomizerNav.addClass("single");
      }
      this.elements.each(function () {
        $(this).parent().remove();
        $(this).appendTo(self.shpfltProductCustomizerItemsContainer);
        let productId = $(this).data("product-id");
        let productTitle = $(this).data("product-title");
        self.shpfltProductCustomizerNav.append(
          `<li class="shpflt-product-customizer-nav-item" data-product-id="${productId}">${productTitle}</li>`
        );
      });
    }

    $(".shpflt-product-customizer-nav-item").on("click", function () {
      if (!$(this).hasClass("active")) {
        return;
      }
      self.activeProduct = $(this).data("product-id");
    });

    $(".customizer-product__tag__modal").on("click", function (e) {
      e.stopPropagation(); // We dont need to refresh the canvas
      let productId = $(this).parents(".customizer-product").data("id");
      console.log(productId);
    });

    $(`.customizer-modal .modal .close-btn`).on("click", function () {
      $(this).parents(".modal").hide();
    });

    this.shpfltProductCustomizerActionBtn.on("click", () => {
      self.activeProduct = this.elements.first().data("product-id");
      this.toggleProductCustomizer();
    });

    $(".customizer-advanced-configuration__link").on("click", function () {
      $(this).parent().toggleClass("active");
      let state = $(this).parent().hasClass("active");
      $(this)
        .find("i")
        .removeClass("fa-chevron-down fa-chevron-up")
        .addClass(state ? "fa-chevron-up" : "fa-chevron-down");
    });

    // When a collection/item is selected
    $(".customizer-item").on("click", function () {
      self.shpfltProductCustomizerItemsContainer
        .find(
          `.shpflt-product-customizer-item[data-product-id='${self.activeProduct}']`
        )
        .attr("data-customizing", "true");
      self.shpfltProductCustomizerNav.removeClass("active");
      $(".customizer-body").removeClass("active");
      $(this)
        .getBody()
        .addClass("active")
        .find(".customizer-product")
        .attr(
          "data-product-back",
          $(this).getBody().find(".customizer-product.active").data("id")
        );
      $(".shpflt-product-customizer-title").text($(this).data("title"));
    });

    // When a product is selected
    $(".customizer-product").on("click", function () {
      if ($(this).hasClass("disabled")) {
        return;
      }
      let productCustomizer = $(this).parent().find(".customizer-product");
      productCustomizer.removeClass("active");
      $.each(productCustomizer, function (i, element) {
        self.shpfltProductCustomizerItemsContainer
          .find(
            ".customizer-product__options[data-id='" +
              $(element).data("id") +
              "']"
          )
          .removeClass("active");
      });
      $(this)
        .parents(".shpflt-product-customizer-item")
        .find(
          ".customizer-product__options[data-id='" + $(this).data("id") + "']"
        )
        .addClass("active")
        .parents(".customizer-body")
        .addClass("customizing");
      $(this).addClass("active");
      self.update();
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: productCustomizer.offset().top - 200,
        },
        500
      );
    });

    // When back button is clicked
    $(".shpflt-product-customizer-back-btn").on("click", function (e) {
      let containerBody = $(e.currentTarget).parents(".customizer-body");
      containerBody.removeClass("customizing");
      let previousSelectedProduct = containerBody
        .parents(".shpflt-product-customizer-item")
        .find(
          ".customizer-product[data-id='" +
            containerBody.find(".customizer-product").data("product-back") +
            "']"
        );
      self.shpfltProductCustomizerNav.addClass("active");

      containerBody.find(".customizer-product").removeClass("active");
      // Click the previous selected product
      previousSelectedProduct.trigger("click");
      // Go to options page
      self.shpfltProductCustomizerItemsContainer
        .find(".shpflt-product-customizer-item")
        .removeAttr("data-customizing")
        .find(".customizer-body.active")
        .removeClass("active")
        .removeClass("customizing");
      $(".shpflt-product-customizer-title").text(
        $(".shpflt-product-customizer-title").attr("title")
      );
    });
    // When the form is submitted
    $("#shpflt-product-customizer-container button[type='submit']").on(
      "click",
      (e) => {
        e.preventDefault();
        let selectedProducts = this.selectedProductItems;
        let payload = {
          items: [],
        };
        let timestamp = dayjs().format("YYMMDD-HHmmss");
        self.shpfltProductCustomizerItemsContainer
          .find(
            `.shpflt-product-customizer-item[data-product-id='${self.activeProduct}']`
          )
          .find(".customizer-body")
          .each(function () {
            let selectedProduct = selectedProducts.find(
              (s) => s.name === $(this).data("collection")
            );
            let selectedProductIds = selectedProducts
              .filter((p) => typeof p.product !== "undefined")
              .sort((a, b) => a.product.id - b.product.id)
              .map((s) =>
                s.product.id
                  .toString()
                  .substr(s.product.id.toString().length - 5)
              );
            if (typeof selectedProduct.product !== "undefined") {
              let obj = {
                id: selectedProduct.product.id,
                quantity: selectedProduct.product.quantity,
                properties: {
                  "Custom Product ID": timestamp,
                  ...selectedProduct.product.properties,
                },
              };
              if (self.elements.length > 1) {
                obj.properties["Bundle Code"] = self.bundleCode;
              }
              payload.items.push(obj);
            }
          });
        $.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/add.js",
          data: payload,
          dataType: "json",
          success: function () {
            $(e.currentTarget)
              .parents("form")
              .append(
                '<input type="hidden" name="properties[Custom Product ID]" value="' +
                  payload.items[0].properties["Custom Product ID"] +
                  '">'
              );
            if (self.elements.length > 1) {
              $(e.currentTarget)
                .parents("form")
                .append(
                  '<input type="hidden" name="properties[Bundle Code]" value="' +
                    payload.items[0].properties["Bundle Code"] +
                    '">'
                );
            }
            $(e.currentTarget)
              .parents("form")
              .submit()
              .find(
                'input[name="properties[Custom Product ID]"], input[name="properties[Bundle Code]"]'
              )
              .remove();
            self.nextProduct();
          },
        });
      }
    );

    // When the apply button is clicked
    $(".shpflt-product-customizer-apply-btn").on("click", (e) => {
      self.shpfltProductCustomizerItemsContainer
        .find(".shpflt-product-customizer-item")
        .removeAttr("data-customizing")
        .find(".customizer-body.active")
        .removeClass("active");
      self.shpfltProductCustomizerNav.addClass("active");
      $(e.currentTarget).parents(".customizer-body").removeClass("customizing");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: 0,
        },
        500
      );
      self.update();
      $(".shpflt-product-customizer-title").text(
        $(".shpflt-product-customizer-title").attr("title")
      );
    });
  }

  update() {
    let totalPrice = this.productPrice;
    let selectedProducts = this.selectedProductItems.filter(
      (p) => typeof p.product !== "undefined"
    );
    $.each(selectedProducts, function (i, element) {
      totalPrice += (element.product.price / 100) * (element.product?.quantity || 1);
    });
    this.productPrice = totalPrice
      .toLocaleString("en-US", {
        style: "currency",
        currency: "EUR",
      })
      .replace(/,/g, ".")
      .replace(/\./g, ",");
    this.addImagesToCanvas(selectedProducts.map((s) => s.product.image));
    this.shpfltProductCustomizerItemsContainer
      .find(
        `.shpflt-product-customizer-item[data-product-id='${this.activeProduct}'] .customizer-item`
      )
      .each(function () {
        $(this).updateSelectedProductText();
      });
  }

  toggleProductCustomizer() {
    this.shpfltProductCustomizerContainer.toggleClass("active");
    let status = this.shpfltProductCustomizerContainer.hasClass("active");
    this.shpfltProductCustomizerNav.toggleClass("active", status);
    $("html").attr("data-customizing", status);
    if (status) {
      this.update();
      if (this.elements.length > 1) {
        this.bundleCode = `${dayjs().format("HHmmss")}`;
      }
    } else {
      this.shpfltProductCustomizerContainer
        .removeClass("active")
        .find(
          ".shpflt-product-customizer-nav-item,.shpflt-product-customizer-item.active"
        )
        .removeClass("active")
        .find(".customizer-product[data-selected='true']")
        .addClass("active");
      this.update();
    }
  }

  customizeProduct(productId) {
    $(
      `.shpflt-product-customizer-item,.shpflt-product-customizer-nav-item`
    ).each(function () {
      if ($(this).data("product-id") != productId) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });
    this.update();
  }
}

let shpfltMultiProductCustomizer = new ShpfltMultiProductCustomizer(
  $(".shpflt-product-customizer-item")
);
